<template>
  <div class="profile-wrap display-flex-center">
    <div class="organization-box small" :class="{ 'loading': isProcessing }">
      <h4 class="title">{{$t('TEXT_INFORMATION')}}</h4>
      <div class="flex-box">
        <div class="fields">
          <div class="field">
            <div class="field-label">{{$t('TEXT_NEW_PASSWORD')}}</div>
            <div class="field-input">
              <el-input v-model="form.newPassword" type="password"></el-input>
            </div>
          </div>
          <div class="field">
            <div class="field-label">{{$t('TEXT_CONFIRM_PASSWORD')}}</div>
            <div class="field-input">
              <el-input v-model="form.confirmPassword" type="password"  @keyup.enter.native="resetPassword()"></el-input>
            </div>
          </div>
          <div class="field">
            <div class="field-label">&nbsp;</div>
            <el-button type="primary" @click="resetPassword" :disabled="!isValidated" class="btn btn-primary"
              >{{ $t('BTN_RESET_PASSWORD') }}</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      isProcessing: false,
      form: {
        newPassword: '',
        confirmPassword: '',
        code: ''
      },
      formLabelWidth: '120px'
    }
  },
  computed: {
    isValidated () {
      return this.form.code && this.form.newPassword && this.form.confirmPassword &&
        this.form.newPassword === this.form.confirmPassword
    }
  },
  created () {
    this.form.code = this.$route.query.code || ''
  },
  methods: {
    async resetPassword () {
      if (!this.isValidated) return
      this.isProcessing = true
      const result = await this.$store.dispatch('resetPassword', this.form)
      this.isProcessing = false
      if (result) this.$router.push({ name: 'landing' })
    }
  }
}
</script>
